export default "__VITE_ASSET__BaZnW8Jo__"